export enum EntityStatuses {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}
